import { SlideComponentCharacterCards } from '@/types/slide';
import { SlideComponentCreator } from './factory';

export class SlideComponentCharacterCardsCreator extends SlideComponentCreator {
    public create(id: string): SlideComponentCharacterCards {
        return {
            id: id,
            pos: {
                x: 0,
                y: 0,
            },
            size: {
                width: 644,
                height: 468,
            },
            type: 'characterCards',
            content: {
                code: '',
                locale: '',
                character: '',
                cardType: 0,
                serial1: [],
                serial2: [],
                settings: {
                    gameType: 'First',
                },
            },
        };
    }
}
